import script from "./BulkPricingPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkPricingPopover.vue?vue&type=script&setup=true&lang=js"

import "./BulkPricingPopover.vue?vue&type=style&index=0&id=4eaaea60&lang=scss"

const __exports__ = script;

export default __exports__